import React, { useState } from 'react';
import { Calendar } from 'primereact/calendar';
import { InputField, NumberField } from '../../../../components/Stepper/fields/inputField';
import { Dropdown } from 'primereact/dropdown';
import { debtType } from '../../../../utility/data';

const LiabilityForm = ({ onSubmit, groupsData }) => {
  const [assetData, setAssetData] = useState({
    name: '',
    inclusion: '',
    linkedWith: '',
    debtType: '',
    date: null,
    firstRank: '',
    Interest: '',
    period: '',
  });

  const [formErrors, setFormErrors] = useState({});

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = validateForm();
    if (Object.keys(errors).length === 0) {
      onSubmit(assetData);
    } else {
      setFormErrors(errors);
    }
  };

  const validateForm = () => {
    const errors = {};
    if (!assetData.name) errors.name = 'Name is required';
    if (!assetData.inclusion) errors.inclusion = 'Inclusion details are required';
    if (!assetData.debtType) errors.debtType = 'Debt type is required';
    if (!assetData.linkedWith) errors.linkedWith = 'Linked With is required';
    if (!assetData.date) errors.date = 'Date is required';
    if (!assetData.firstRank) errors.firstRank = '1st Rank is required';
    if (!assetData.Interest) errors.Interest = 'Interest is required';
    if (!assetData.period) errors.period = 'Period is required';
    return errors;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setAssetData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setFormErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
  };

  const handleDateChange = (e) => {
    setAssetData((prevData) => ({
      ...prevData,
      date: e.value,
    }));
    setFormErrors((prevErrors) => ({ ...prevErrors, date: '' }));
  };

  return (
    <div>
      <h2 className="text-2xl font-semibold mb-6 text-secondary">General</h2>
      <form onSubmit={handleSubmit}>
        <div className="grid md:grid-cols-2 gap-5 text-primary mb-8">
          <InputField
            label="Name"
            placeholder="Enter your name"
            name="name"
            value={assetData.name}
            onChange={handleInputChange}
            required={false}
            errors={formErrors.name}
          />

          <div className="w-full">
            <label className="block mb-2 text-lg text-white font-semibold">Include In</label>
            <Dropdown
              value={assetData.inclusion}
              name="inclusion"
              onChange={handleInputChange}
              options={groupsData}
              optionLabel="name"
              placeholder="Select include In"
              className={`w-full bg-transparent border border-gray-300 rounded-lg ${assetData.inclusion ? "asset_Dropdown" : ""}`}

            />
            {formErrors.inclusion && <p className="text-red-500">{formErrors.inclusion}</p>}
          </div>
          <div className="w-full">
            <label className="block mb-2 text-lg text-white font-semibold">Debt Type</label>
            <Dropdown
              value={assetData.debtType}
              name="debtType"
              onChange={handleInputChange}
              options={debtType}
              optionLabel="name"
              placeholder="Enter debt type"
              className="asset_Dropdown w-full bg-transparent text-gray-100 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
            />
            {formErrors.debtType && <p className="text-red-500">{formErrors.debtType}</p>}
          </div>

          <InputField
            label="Linked With"
            placeholder="Enter linked with"
            name="linkedWith"
            value={assetData.linkedWith}
            onChange={handleInputChange}
            required={false}
            errors={formErrors.linkedWith}
          />

        </div>

        <div className="grid md:grid-cols-4 gap-5 text-primary mb-8 mt-16">
          <div className='flex flex-col justify-end'>
            <div className="w-full flex items-end space-x-4">
              <label className="block text-sm text-white font-semibold">Date</label>
              <Calendar
                id="date"
                value={assetData.date}
                onChange={handleDateChange}
                className="asset_date"
                placeholder="Select a date"
                dateFormat="dd/mm/yy"
              />
            </div>
            {formErrors.date && <p className="text-red-500 text-center">{formErrors.date}</p>}
          </div>


          <NumberField
            label="1st Rank"
            name="firstRank"
            value={assetData.firstRank}
            onChange={handleInputChange}
            required={false}
            errors={formErrors.firstRank}
          />


          <NumberField
            label="Interest"
            name="Interest"
            value={assetData.Interest}
            onChange={handleInputChange}
            required={false}
            errors={formErrors.Interest}
          />


          <NumberField
            label="Period"
            name="period"
            value={assetData.period}
            onChange={handleInputChange}
            required={false}
            errors={formErrors.period}
          />

        </div>

        <div className='flex md:justify-end justify-center'>
          <button
            type="submit"
            className="px-6 py-2 text-primary bg-secondary hover:bg-secondary rounded-lg"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  );
};

export default LiabilityForm;
